// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import { fetchRewards } from '../api';
import { call, put } from 'redux-saga/effects';
import { rewardsFetched, rewardsFetchFailed } from '../reducer/rewardsSlice';

export function* fetchRewardsSaga(action) {
  const { accountId, cardLastFourDigits } = action.payload;
  const trimmedAccountId = accountId.replace(/^0+/, '');
  try {
    const response = yield call(
      fetchRewards,
      'reward_balance',
      trimmedAccountId,
      cardLastFourDigits
    );
    yield put(rewardsFetched(response));
  } catch (error) {
    console.log('Error rewards', error);

    // Dispatch only the serialized error message to avoid non-serializable values
    yield put(
      rewardsFetchFailed(
        error.message || 'An error occurred while fetching rewards'
      )
    );
  }
}
